import React, { useEffect } from 'react';
import { Button, Form } from 'antd';

import DrawerFrame from 'components/components/Drawer/Frame';
import { FormBuilder } from 'components/components';
import { scrollToFirstError } from 'components/components/FormBuilder/utils/helpers';
import { ventureBuilderDescriptionFields } from 'components/VentureBuilderForms';
import { useUpdateVentureBuilder } from 'packages/venture_builder_repository';
import showNotification from 'services/utils/showNotification';
import { EditVentureBuilderDrawerProps, EditVentureBuilderFormValues } from 'types/ventureBuilders';

const EditVentureBuilderDrawer = ({ open, ventureBuilder, onClose }: EditVentureBuilderDrawerProps) => {
  const [form] = Form.useForm<EditVentureBuilderFormValues>();
  const { mutate, isPending } = useUpdateVentureBuilder(ventureBuilder.id);

  useEffect(() => {
    if (open) {
      form.setFieldsValue({
        description: ventureBuilder.description,
      });
    }
  }, [open, ventureBuilder, form]);

  const handleSubmit = (values: EditVentureBuilderFormValues) => {
    mutate({ description: values.description }, {
      onSuccess: () => {
        showNotification('Venture Builder has been updated');
        onClose();
      },
      onError: (error) => {
        showNotification(error.message, true, 400);
      },
    });
  };

  return (
    <DrawerFrame
      forceRender
      title="Edit venture builder"
      open={open}
      onClose={onClose}
    >
      <Form
        className="form-standalone"
        form={form}
        onFinish={handleSubmit}
        onFinishFailed={scrollToFirstError}
        validateTrigger="onChange"
      >
        <FormBuilder oneColumn formFragment fields={ventureBuilderDescriptionFields} />
        <div className="drawer-buttons">
          <Button className="secondary-button" onClick={onClose}>Cancel</Button>
          <Button className="primary-button" htmlType="submit" disabled={isPending}>Save changes</Button>
        </div>
      </Form>
    </DrawerFrame>
  );
};

export default EditVentureBuilderDrawer;
